var React = require('react');

function SortDirection (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_trending_flat_24px","d":"M13,4,9,8V5H0V3H9V0Z","transform":"translate(0 13) rotate(-90)","fill":"#fff"}));
}

SortDirection.defaultProps = {"width":"8","height":"13","viewBox":"0 0 8 13"};

module.exports = SortDirection;

SortDirection.default = SortDirection;
